export default "__VITE_ASSET__DF$HSVMd__"